<app-dialog-wrapper
    heading="request.requestDetail.setRequestActiveDialog.title"
    description="request.requestDetail.setRequestActiveDialog.description"
    confirmLabel="request.requestDetail.setRequestActiveDialog.confirm"
    cancelLabel="request.requestDetail.setRequestActiveDialog.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
</app-dialog-wrapper>
